import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AdminPatients = () => {
  const [patients, setPatients] = useState([]);
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [invoices, setInvoices] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchPatients = async () => {
      try {
        const res = await axios.get('https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/admin/patients');
        setPatients(res.data);
      } catch (err) {
        console.error('Erreur récupération patients :', err);
      }
    };
    fetchPatients();
  }, []);

  const handleViewDetails = async (patientId) => {
    if (selectedPatientId === patientId) {
      setSelectedPatientId(null);
      setInvoices([]);
      setAppointments([]);
      return;
    }

    setSelectedPatientId(patientId);
    try {
      const [invoiceRes, appointmentRes] = await Promise.all([
        axios.get(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/admin/patients/${patientId}/invoices`),
        axios.get(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/admin/patients/${patientId}/appointments`)
      ]);
      setInvoices(invoiceRes.data);
      setAppointments(appointmentRes.data);
    } catch (err) {
      console.error('Erreur récupération factures ou rendez-vous :', err);
      setInvoices([]);
      setAppointments([]);
    }
  };

  const filteredPatients = patients.filter((p) => {
    const query = searchTerm.toLowerCase();
    return (
      p.first_name.toLowerCase().includes(query) ||
      p.last_name.toLowerCase().includes(query) ||
      p.email.toLowerCase().includes(query) ||
      p.phone?.toLowerCase().includes(query) ||
      p.birth_date?.toLowerCase().includes(query)
    );
  });

  return (
    <div style={{ padding: '30px', fontFamily: 'Arial' }}>
      <h2 style={{ marginBottom: '20px' }}>👥 Liste des usagers</h2>

      <input
        type="text"
        placeholder="🔍 Rechercher un usager par nom, email, téléphone..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          padding: '10px',
          width: '100%',
          marginBottom: '20px',
          borderRadius: '6px',
          border: '1px solid #ccc',
          fontSize: '16px'
        }}
      />

      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '40px' }}>
        <thead style={{ backgroundColor: '#f0f0f0' }}>
          <tr>
            <th style={{ padding: '10px', textAlign: 'left' }}>Nom</th>
            <th style={{ padding: '10px', textAlign: 'left' }}>Email</th>
            <th style={{ padding: '10px', textAlign: 'left' }}>Téléphone</th>
            <th style={{ padding: '10px', textAlign: 'left' }}>Naissance</th>
            <th style={{ padding: '10px' }}>Détails</th>
          </tr>
        </thead>
        <tbody>
          {filteredPatients.map((p) => (
            <React.Fragment key={p.user_id}>
              <tr style={{ borderBottom: '1px solid #ddd' }}>
                <td style={{ padding: '10px' }}>{p.first_name} {p.last_name}</td>
                <td style={{ padding: '10px' }}>{p.email}</td>
                <td style={{ padding: '10px' }}>{p.phone}</td>
                <td style={{ padding: '10px' }}>{p.birth_date}</td>
                <td style={{ padding: '10px' }}>
                  <button
                    onClick={() => handleViewDetails(p.user_id)}
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#007bff',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    {selectedPatientId === p.user_id ? 'Masquer' : 'Voir détails'}
                  </button>
                </td>
              </tr>

              {selectedPatientId === p.user_id && (
                <tr>
                  <td colSpan="5" style={{ backgroundColor: '#f9f9f9' }}>
                    <div style={{ display: 'flex', gap: '40px', padding: '20px' }}>
                      {/* Factures */}
                      <div style={{ flex: 1 }}>
                        <h4>🧾 Factures</h4>
                        {invoices.length === 0 ? (
                          <p style={{ fontStyle: 'italic' }}>Aucune facture.</p>
                        ) : (
                          <ul>
                            {invoices.map((inv) => (
                              <li key={inv.invoice_id}>
                                <strong>{(inv.amount_cents / 100).toFixed(2)} $</strong> — {inv.service_name} <br />
                                <small>{inv.created_at} — Statut : <strong>{inv.status}</strong></small>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>

                      {/* Rendez-vous */}
                      <div style={{ flex: 1 }}>
                        <h4>📅 Rendez-vous</h4>
                        {appointments.length === 0 ? (
                          <p style={{ fontStyle: 'italic' }}>Aucun rendez-vous.</p>
                        ) : (
                          <ul>
                            {appointments.map((appt) => (
                              <li key={appt.appointment_id}>
                                <strong>{appt.start_time}</strong> avec {appt.professional_name} <br />
                                <small>{appt.service_name} — Statut : <strong>{appt.status}</strong></small>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminPatients;